import React from 'react';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/checkmark-grey.svg';

const AuthernticationInfo = () => {
  const data = [
    {
      text: 'Streamline Budget Management',
      subtext:
        'Easily allocate budgets to employees, ensuring efficient and cost-effective food ordering from the Foodcourt app.'
    },
    {
      text: 'Event Hosting and Employee Birthdays',
      subtext:
        'Seamlessly plan virtual events, invite guests and manage event budgets. Plus, celebrate your employees on their birthdays and special occasions.'
    },
    {
      text: 'Simplified Bulk Ordering',
      subtext:
        'Handle large-scale food and drink orders for gatherings and get-togethers effortlessly, making company events a breeze to organize'
    }
  ];
  return (
    <div className='min-h-screen  pl-[20px] md:pl-[45px] pt-[90px]'>
      <p className='w-[450px] text-[32px] font-semibold mb-[72px] text-white'>{`Let’s help you take care of your people needs`}</p>
      {data.map(({ text, subtext }, index) => (
        <div className='flex gap-4 justify-start pb-16' key={index}>
          <div>
            <CheckmarkIcon />
          </div>
          <div className='w-[330px]'>
            <p className='text-[18px] font-medium text-white'> {text}</p>
            <p className='text-[16px] text-[#D1D1D1] mt-1'>{subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuthernticationInfo;
